import { createAsyncThunk } from '@reduxjs/toolkit';

import { notificationsService } from '../../services/insightt-services/notifications.service';
import {
  DELETE_ALL_NOTIFICATION,
  DELETE_NOTIFICATION,
  GET_NOTIFICATION,
  MARK_ALL_NOTIFICATION_AS_READ,
  MARK_NOTIFICATION_AS_READ,
  MORE_NOTIFICATION,
} from './types';
import { InsighttNotification } from '../../helpers/insightt-notification';
import { PAGE_SIZE } from '../../constants/app.constants';

export const getNotifications = createAsyncThunk(
  GET_NOTIFICATION,
  async (config: Record<string, string | boolean> | undefined, thunkApi) => {
    try {
      const response = await notificationsService.getNotifications(1, PAGE_SIZE, config);

      if (!response?.data) {
        throw new Error('Error getting notifications.');
      }
      return thunkApi.fulfillWithValue(response?.data);
    } catch (err) {
      InsighttNotification('error', 'Error getting notifications.', err);
      return thunkApi.rejectWithValue(new Error(String(err)));
    }
  },
);

export const getMoreNotifications = createAsyncThunk(MORE_NOTIFICATION, async (nextPage: number, thunkApi) => {
  try {
    const response = await notificationsService.getNotifications(nextPage, PAGE_SIZE);

    if (!response?.data) {
      throw new Error('Error getting more notifications.');
    }
    return thunkApi.fulfillWithValue(response?.data);
  } catch (err) {
    InsighttNotification('error', 'Notification error', err);
    return thunkApi.rejectWithValue(new Error(String(err)));
  }
});

export const markAsRead = createAsyncThunk(MARK_NOTIFICATION_AS_READ, async (notificationId: number, thunkApi) => {
  try {
    const response = await notificationsService.markAsReadNotifications({
      ids: [notificationId],
    });
    if (!response?.data) {
      throw new Error('Error marking Notification as read.');
    }
    InsighttNotification('success', 'Notification has been marked as read!');
    return thunkApi.fulfillWithValue(notificationId);
  } catch (err) {
    InsighttNotification('error', 'Error marking Notification as read.', err);
    return thunkApi.rejectWithValue(err);
  }
});

export const markAllAsRead = createAsyncThunk(MARK_ALL_NOTIFICATION_AS_READ, async (_, thunkApi) => {
  try {
    const response = await notificationsService.markAsReadAllNotifications();
    if (!response?.data?.success) {
      throw new Error('Error Marking all Notifications as Read');
    }
    InsighttNotification('success', 'All notifications have been marked as read!');
    thunkApi.dispatch(getNotifications({ fromCache: false }));
  } catch (err) {
    InsighttNotification('error', 'Error Marking all Notifications as Read', err);
    return thunkApi.rejectWithValue(new Error(String(err)));
  }
});

export const deleteNotification = createAsyncThunk(
  DELETE_NOTIFICATION,
  async (notificationId: number, thunkApi) => {
    try {
      const response = await notificationsService.deleteNotification(notificationId);
      if (!response?.data) {
        throw new Error('Error deleting notification.');
      }
      InsighttNotification('success', 'Notification has been deleted!');
      return thunkApi.fulfillWithValue(notificationId);
    } catch (err) {
      InsighttNotification('error', 'Error deleting notification.', err);
      return thunkApi.rejectWithValue(err);
    }
  },
);

export const deleteAllNotification = createAsyncThunk(DELETE_ALL_NOTIFICATION, async (_, thunkApi) => {
  try {
    const response = await notificationsService.deleteNotifications({
      removeAll: true,
    });

    if (!response?.data) {
      throw new Error('An error occurred while deleting all notifications');
    }
    InsighttNotification('success', 'All notifications have been deleted!');
    thunkApi.dispatch(getNotifications({ fromCache: false }));
  } catch (err) {
    InsighttNotification('error', 'An error occurred while deleting all notifications', err);
    return thunkApi.rejectWithValue(err);
  }
});
